import { useState } from 'react';

import type { CashAccountChoice } from '@core/api/cash';
import { splitParts, type SplitPart } from '@core/cash/split';

/**
 * The boxes' state: none until something is typed, so they come from the accounts as they load and a
 * refetch never loses a figure. `start` fills them the first time (the amount owed into the till);
 * `reset` puts them back to it — when what the money is for changes.
 */
export function useSplitParts(
  accounts: readonly CashAccountChoice[] | undefined,
  start: (fresh: SplitPart[]) => SplitPart[] = (fresh) => fresh,
) {
  const [edits, setEdits] = useState<SplitPart[] | null>(null);
  const parts = edits ?? start(splitParts(accounts));
  const change = (next: (current: SplitPart[]) => SplitPart[]) =>
    setEdits((current) => next(current ?? start(splitParts(accounts))));

  return { parts, change, reset: () => setEdits(null) };
}
